<template lang='pug'>
  i.svg-icon.svg-icon-logOut
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M69.67,23.311c14.828,10.586,18.266,31.191,7.679,46.022 c-10.59,14.828-31.192,18.267-46.021,7.68c-14.83-10.587-18.268-31.191-7.681-46.019c2.119-2.968,4.713-5.564,7.681-7.683 c1.435-1.031,3.436-0.705,4.469,0.731c0.068,0.095,0.131,0.193,0.188,0.295l2.104,3.737c0.789,1.399,0.413,3.165-0.875,4.124 c-9.921,7.342-12.012,21.34-4.67,31.259c7.344,9.924,21.34,12.012,31.259,4.67c9.924-7.342,12.012-21.34,4.67-31.259 c-1.318-1.778-2.888-3.351-4.67-4.67c-1.28-0.955-1.652-2.718-0.864-4.109l2.104-3.737c0.86-1.539,2.809-2.084,4.344-1.22 C69.48,23.189,69.579,23.247,69.67,23.311z M55.823,51.234V19.312c0.004-1.763-1.421-3.191-3.18-3.195c-0.004,0-0.008,0-0.012,0 h-4.268c-1.761-0.004-3.192,1.417-3.195,3.176c0,0.008,0,0.011,0,0.019v31.922c-0.004,1.759,1.419,3.191,3.178,3.195 c0.005,0,0.011,0,0.017,0h4.268c1.763,0,3.188-1.425,3.191-3.184C55.823,51.242,55.823,51.238,55.823,51.234z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>